module.exports = __webpack_public_path__ + "img/periode_akhir.13efa940.svg";